<header class="text-bg-primary" style="z-index: 5; position: relative" #header>
  <div class="container-fluid h-100 d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center gap-4">
      <!-- Logo & title -->
      <div class="d-flex align-items-center gap-3">
        <svg-icon *ngIf="!showLogoText" src="/assets/txd-symbol.svg"></svg-icon>
        <svg-icon *ngIf="showLogoText" src="/assets/txd-logo-white.svg"></svg-icon>
        <div *ngIf="!isDocumentLoaded">Online Document Editor</div>
      </div>

      <!-- Contact & Case info -->
      <div [class]="stackContactAndCase ? 'd-flex flex-column stacked' : 'd-flex align-items-center gap-4 '">
        <ng-container *ngIf="isDocumentLoaded">
          <div *ngIf="editorMeta.ctcFirstName != null" class="d-flex align-items-center gap-1" #contactAndCase>
            <i class="bi bi-folder2"></i>
            <span>{{ editorMeta.ctcFirstName }} {{ editorMeta.ctcLastName }}</span>
            <span class="d-flex align-items-center">- {{ editorMeta.casDescription }}</span>
          </div>
        </ng-container>

        <div class="d-flex align-items-center gap-1" #fileName *ngIf="!isLoading">
          <i class="bi bi-file-earmark"></i>
          <span *ngIf="editorMeta.filename; else noFileName">
            {{ editorMeta.filename }}
          </span>
          <ng-template #noFileName>
            <span>Untitled Document</span>
          </ng-template>
          <span *ngIf="isDirty">*</span>
          
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center gap-2">
      <!-- Save button -->
      <button
        type="button"
        class="btn btn-header btn-outline-light save-button d-flex align-items-center gap-2"
        (click)="save()">
        <svg-icon src="/assets/content-save.svg"></svg-icon>
        <span *ngIf="showSaveButtonText">Save document</span>
      </button>

      <!-- Download button -->
      <button
        type="button"
        class="btn btn-header btn-outline-light download-button d-flex align-items-center gap-2"
        (click)="download()"
        ngbTooltip="Download document"
        container="body"
        [openDelay]="800">
        <i class="bi-download"></i>
      </button>

      <!-- Print button -->
      <button
        type="button"
        class="btn btn-header btn-outline-light print-button d-flex align-items-center gap-2"
        (click)="print()"
        ngbTooltip="Print document"
        container="body"
        [openDelay]="800">
        <i class="bi-printer-fill"></i>
      </button>

      <div class="vertical-divider"></div>
      <div class="p-2">{{ initials }}</div>
      <button type="button" class="btn btn-header icon-button btn-outline-light" (click)="logout()">Logout</button>
    </div>
  </div>
</header>
